import React from "react";
import CapitalSummaryCard from "../CapitalSummaryCard";

const SummaryCardsContainer = ({ cards }) => {
  return (
    <div className="capital-summary-container">
      {cards.map((card, index) => (
        <CapitalSummaryCard
          key={index}
          title={card.title}
          value={card.value}
          type={card.type}
          tooltip={card.tooltip}
        />
      ))}
    </div>
  );
};

export default SummaryCardsContainer; 